// src/lib/sam-api/debug-raw-data.ts - TEMPORARY DEBUG SCRIPT
import { samApi } from './client';

export class DebugRawSamData {
  static async inspectRawData(): Promise<void> {
    console.log('🔍 Starting raw SAM.gov data inspection...');
    
    try {
      // Get one contract with debug mode on
      const response = await samApi.searchContracts({
        size: 1,
        debug: true
      });
      
      if (response.items && response.items.length > 0) {
        const contract = response.items[0];
        console.log('📦 Sample transformed contract structure:');
        console.log(JSON.stringify(contract, null, 2));
        
        // Check if we have metadata with original data
        if (contract.metadata?.originalData) {
          console.log('\n🔍 RAW SAM.gov opportunity data:');
          console.log('=====================================');
          console.log(JSON.stringify(contract.metadata.originalData, null, 2));
          
          console.log('\n📊 Available fields in raw data:');
          console.log('==================================');
          const fields = Object.keys(contract.metadata.originalData);
          fields.forEach(field => {
            const value = contract.metadata.originalData[field];
            console.log(`${field}: ${typeof value} - ${Array.isArray(value) ? `Array(${value.length})` : value?.toString?.()?.substring?.(0, 100) || 'null'}`);
          });
        }
      } else {
        console.log('❌ No contracts returned');
      }
    } catch (error) {
      console.error('💥 Debug failed:', error);
    }
  }
}